import React, { useState } from 'react';
import { Modal } from './ui/Modal';
type LegalDoc = 'privacy' | 'terms' | null;
function PrivacyContent() {
  return <>
      <p className="text-sm text-slate-500" data-id="element-69">
        Last updated: {new Date().getFullYear()}
      </p>
      <p data-id="element-70">
        This Privacy Policy explains how information is collected, used, and
        protected when you purchase and use The Elite Striker's IQ Map digital
        playbook.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-71">
        Information We Collect
      </h3>
      <p data-id="element-72">
        When you complete a purchase, we collect the information necessary to
        deliver your digital product, such as your name and the email address
        used for instant delivery. Payment details are processed securely by our
        payment provider and are never stored on our servers.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-73">
        How We Use Your Information
      </h3>
      <p data-id="element-74">
        Your information is used solely to deliver the digital playbook, provide
        access to your purchase, and send essential transactional messages
        related to your order. We do not sell or rent your personal information
        to third parties.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-75">Data Security</h3>
      <p data-id="element-76">
        We use industry-standard safeguards to protect your information during
        transmission and storage. While no method of transmission is completely
        secure, we are committed to protecting your data using commercially
        acceptable means.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-77">Your Rights</h3>
      <p data-id="element-78">
        You have the right to request access to, correction of, or deletion of
        the personal information associated with your purchase, subject to
        applicable law and our legitimate record-keeping obligations.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-79">
        Changes to This Policy
      </h3>
      <p data-id="element-80">
        We may update this Privacy Policy from time to time. Any changes will be
        reflected on this page with an updated revision date.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-slate-500" data-id="element-81">
        Last updated: {new Date().getFullYear()}
      </p>
      <p data-id="element-82">
        By purchasing and using The Elite Striker's IQ Map, you agree to the
        following terms and conditions. Please read them carefully.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-83">Digital Product</h3>
      <p data-id="element-84">
        The Elite Striker's IQ Map is a digital PDF bundle delivered instantly
        upon purchase. It is intended for personal, non-commercial use by the
        purchasing household.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-85">License & Use</h3>
      <p data-id="element-86">
        Upon purchase, you receive a personal, non-transferable license to
        access and use the materials. You may not resell, redistribute,
        reproduce, or share the contents with third parties without prior
        written permission.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-87">No Guarantees</h3>
      <p data-id="element-88">
        The training protocols and timelines described are based on typical
        results and are provided for educational purposes. Individual outcomes
        will vary based on consistency, effort, and individual ability. No
        specific athletic or performance result is guaranteed.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-89">Intellectual Property</h3>
      <p data-id="element-90">
        All content, frameworks, and materials within The Elite Striker's IQ Map
        are protected by intellectual property laws and remain the property of
        the publisher.
      </p>
      <h3 className="text-lg text-tactical-cyan pt-2" data-id="element-91">
        Limitation of Liability
      </h3>
      <p data-id="element-92">
        Physical training carries inherent risks. The materials are provided "as
        is," and the publisher is not liable for any injury or damages arising
        from the use of the drills or protocols described.
      </p>
    </>;
}
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc>(null);
  return <footer className="relative z-10 border-t border-tactical-surface2 bg-tactical-dark py-10 px-6" data-id="element-93">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4 text-center" data-id="element-94">
        <p className="text-slate-500 font-inter text-sm" data-id="element-95">
          © {new Date().getFullYear()} The Elite Striker's IQ Map. All rights
          reserved.
        </p>
        <nav className="flex items-center gap-6 font-inter text-sm" data-id="element-96">
          <button onClick={() => setOpenDoc('privacy')} className="text-slate-400 hover:text-tactical-cyan transition-colors" data-id="element-97">
            Privacy Policy
          </button>
          <span className="w-1 h-1 rounded-full bg-slate-700" aria-hidden="true" data-id="element-98"></span>
          <button onClick={() => setOpenDoc('terms')} className="text-slate-400 hover:text-tactical-cyan transition-colors" data-id="element-99">
            Terms &amp; Conditions
          </button>
        </nav>
      </div>

      <Modal isOpen={openDoc === 'privacy'} onClose={() => setOpenDoc(null)} title="Privacy Policy" data-id="element-100">
        <PrivacyContent data-id="element-101" />
      </Modal>

      <Modal isOpen={openDoc === 'terms'} onClose={() => setOpenDoc(null)} title="Terms & Conditions" data-id="element-102">
        <TermsContent data-id="element-103" />
      </Modal>
    </footer>;
}